import React, { useEffect, useState } from "react";
import {
  Container,
  Nav,
  Navbar,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
} from "react-bootstrap";
import { useNavigate, Navigate } from "react-router-dom";
import { Buttons } from "../components/Buttons";
import { TableUI } from "../components/Tables";
// import { FaEquals, FaPlus } from "react-icons/fa6";
import { PageHead, PageTitle } from "../components/PageTitle";
import "../components/Table.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import API_DOMAIN from "../config/config";
import { MdOutlineClose } from "react-icons/md";
import moment from "moment/moment";
import companyId from "../config/companyId";
import {
  Calender,
  DropDownUI,
  TextInputForm,
  LoadingSpinner,
} from "../components/Forms";
import PurchaseReceipt from "../pages/PurchaseReceipt";
import { PDFDownloadLink, pdf } from "@react-pdf/renderer";
import Pagnation from "../components/Pagnation";
const ProductHistory = [
  "S.No",
  "Date",
  "Bill No.",
  "Party Name",
  "Amount",
  "Status",
];

const PurchaseBill = () => {
  const [openFilter, setFilter] = useState(false);
  const closeFilter = () => setFilter(false);
  const showFilter = () => setFilter(true);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState("");
  const [printrow, setPrintRow] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleClose = () => {
    setShowModal(false);
    setSelectedOption("");
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const [filterData, setFilterData] = useState({
    search_text: "",
    party_id: "",
    party_name: "",
    from_date: "",
    to_date: "",
  });
  const filteredUserData = userData.filter((item) => {
    const searchText = filterData.search_text?.toLowerCase() || "";
    const billNo = item.bill_no?.toLowerCase() || "";
    const receiptNo = item.receipt_no?.toLowerCase() || "";
    const isReceiptMatch =
      billNo.includes(searchText) || receiptNo.includes(searchText);

    const itemDate = moment(item.bill_date, "DD-MM-YYYY");
    const fromDate = filterData.from_date
      ? moment(filterData.from_date, "DD-MM-YYYY")
      : null;
    const toDate = filterData.to_date
      ? moment(filterData.to_date, "DD-MM-YYYY")
      : null;

    let isDateMatch = true;

    if (fromDate && toDate) {
      isDateMatch = itemDate.isBetween(fromDate, toDate, "day", "[]");
    } else if (fromDate) {
      isDateMatch = itemDate.isSameOrAfter(fromDate, "day");
    } else if (toDate) {
      isDateMatch = itemDate.isSameOrBefore(toDate, "day");
    }

    const isPartyMatch =
      !filterData.party_id || item.party_id === filterData.party_id;

    return isReceiptMatch && isPartyMatch && isDateMatch;
  });

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFilterData({
      ...filterData,
      [fieldName]: value,
    });
  };

  const setLabel = (value, field) => {
    if (!value || !moment(value).isValid()) {
      setFilterData({
        ...filterData,
        [field]: "",
      });
      return;
    }

    const displayFormat = moment(value).format("DD-MM-YYYY");
    setFilterData({
      ...filterData,
      [field]: displayFormat,
    });
  };

  const [dropdownKey, setDropdownKey] = useState(Date.now());
  const clearFilter = () => {
    setFilterData({
      search_text: "",
      party_id: "",
      from_date: "",
      to_date: "",
    });
    setDropdownKey(Date.now()); // force DropDownUI to reset
  };

  const handleClearAll = () => {
    setFilterData({
      search_text: "",
      party_id: "",
      from_date: "",
      to_date: "",
    });
    setDropdownKey(Date.now());
    clearFilter();
    closeFilter(); // reset date fields and dropdown if used
  };
  const [crtPurchase, setPurchase] = useState([]);
  const fetchDataPurchase = async () => {
    try {
      const response = await fetch(
        `${API_DOMAIN}/purchase_party.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: "",
            company_id: companyId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();

      setLoading(false);
      if (responseData.status === 200) {
        setPurchase(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDataPurchase(); // Call fetchData directly in useEffect
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${API_DOMAIN}/purchase_bill.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: filterData.search_text,
            party_id: filterData.party_id,
            from_date: filterData.from_date,
            to_date: filterData.to_date,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      setLoading(false);
      if (responseData.status === 200) {
        setUserData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData(); // Call fetchData directly in useEffect
  }, [filterData]);

  const openPrintView = async (rowData, type) => {
    const blob = await pdf(
      <PurchaseReceipt data={rowData} type={type} />
    ).toBlob();
    const url = URL.createObjectURL(blob);
    const printWindow = window.open(url, "_blank");
    if (!printWindow) {
      return;
    }
    if (type === "Original") {
      printWindow.onload = () => {
        printWindow.print();
        URL.revokeObjectURL(url);
      };
      // Open PDF in new tab without printing
    } else if (type === "Duplicate" || type === "Triplicate") {
      printWindow.onload = () => {
        printWindow.print();
        URL.revokeObjectURL(url);
      };
    }
  };

  const handleOptionChange = (type) => {
    if (selectedRow) {
      openPrintView(selectedRow, type);
    }
    setShowModal(false);
  };

  const handlePurchaseBillPrintclick = async (rowData) => {
    setSelectedRow(rowData);
    setShowModal(true);
  };
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        // Check session logic here, e.g., fetch from local storage or server
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  if (loading) {
    return <LoadingSpinner message="Loading PurchaseBill..." height="300px" />;
  }
  return (
    <div style={{ cursor: "pointer" }}>
      <div>
        <Container fluid className="px-1 pt-2">
          <div className="main p-3 my-2">
            <div className="mx-2">
              <Navbar>
                <Navbar.Brand>
                  <PageTitle PageTitle={"Purchase Bill"} />
                </Navbar.Brand>
                <Nav className="ms-auto">
                  <span className="mx-2 py-2">
                    <Buttons lable={<>Filter</>} onClick={showFilter} />
                  </span>
                  <span className="mx-2 py-2">
                    <Buttons lable={<>Clear</>} onClick={handleClearAll} />
                  </span>
                </Nav>
              </Navbar>
            </div>
            <Offcanvas show={openFilter} onHide={closeFilter} placement="end">
              <Offcanvas.Body>
                <Row>
                  <Col lg="6">
                    <PageTitle PageTitle={<>Purchase Bill</>} />
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="text-end">
                      <Buttons
                        onClick={closeFilter}
                        lable={
                          <>
                            <MdOutlineClose />
                          </>
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <div>
                  <div className="py-3">
                    <TextInputForm
                      key={dropdownKey}
                      labelname={"Search Receipt"}
                      placeholder={"Search Receipt"}
                      name="search_text"
                      value={filterData.search_text}
                      onChange={(e) => handleChange(e, "search_text")}
                    />
                  </div>
                  <div className="py-3">
                    <DropDownUI
                      key={dropdownKey}
                      optionlist={crtPurchase.map((user) => ({
                        value: user.party_id,
                        label: user.party_name,
                      }))}
                      placeholder="PartyName"
                      labelname="PartyName"
                      name="party_id"
                      value={filterData.party_id}
                      onChange={(updatedFormData) =>
                        setFilterData({
                          ...filterData,
                          party_id: updatedFormData.party_id,
                        })
                      }
                    />
                  </div>
                  <Row>
                    <Col lg="6" className="align-self-center">
                      <div>
                        <Calender
                          key={dropdownKey}
                          setLabel={(date) => setLabel(date, "from_date")}
                          selectedDate={filterData.from_date}
                          calenderlabel="From Date"
                        />
                      </div>
                    </Col>
                    <Col lg="6" className="align-self-center">
                      <div>
                        <Calender
                          key={dropdownKey}
                          setLabel={(date) => setLabel(date, "to_date")}
                          selectedDate={filterData.to_date}
                          calenderlabel="To Date"
                        />
                      </div>
                    </Col>

                    <Col lg="6" className="align-self-center">
                      <div className="my-5 text-center">
                        <Buttons lable={"Clear"} onClick={clearFilter} />
                      </div>
                    </Col>
                    <Col lg="6" className="align-self-center">
                      <div className="my-5 text-center">
                        <Buttons
                          lable={"Apply"}
                          onClick={() => {
                            closeFilter();
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
          <div className="main p-3">
            <div className="py-1 mx-2">
              <Navbar>
                <Navbar.Brand>
                  <PageTitle PageTitle={"Transactions"} />
                </Navbar.Brand>
                <Nav className="ms-auto">
                  <span className="mx-2 py-2">
                    <Buttons
                      lable={<>Add New</>}
                      onClick={() => navigate("/console/purchase/bill/create")}
                    />
                  </span>
                </Nav>
              </Navbar>
            </div>
            <div className="py-2 c-table table-scroll">
              <TableUI
                headers={ProductHistory}
                body={filteredUserData}
                type="purchasebill"
                onDelete={fetchData}
                handleEditClick={handlePurchaseBillPrintclick}
                pageview={"yes"}
              />
            </div>
          </div>
          <Modal size="xs" show={showModal} onHide={handleClose} centered>
            <Modal.Header className="position-relative ">
              <Modal.Title className="fs-5 text-center w-100 mt-2 mb-2">
                Print Type
              </Modal.Title>
              <MdOutlineClose
                className="position-absolute end-0 top-0 mt-2 me-2"
                style={{ cursor: "pointer", fontSize: "1.5rem" }}
                onClick={() => setShowModal(false)}
                aria-label="Close Print Type Modal"
              />
            </Modal.Header>
            <Modal.Body>
              <Container>
                <Row>
                  <Col md={4}>
                    <input
                      type="radio"
                      id="original"
                      name="fav_language"
                      value="Original"
                      onChange={(e) => handleOptionChange(e.target.value)}
                    />
                    <label htmlFor="original">Original</label>
                  </Col>
                  <Col md={4}>
                    <input
                      type="radio"
                      id="duplicate"
                      name="fav_language"
                      value="Duplicate"
                      onChange={(e) => handleOptionChange(e.target.value)}
                    />
                    <label htmlFor="duplicate">Duplicate</label>
                  </Col>
                  <Col md={4}>
                    <input
                      type="radio"
                      id="triplicate"
                      name="fav_language"
                      value="Triplicate"
                      onChange={(e) => handleOptionChange(e.target.value)}
                    />
                    <label htmlFor="triplicate">Triplicate</label>
                  </Col>
                </Row>
              </Container>
            </Modal.Body>
          </Modal>
        </Container>
      </div>
    </div>
  );
};

export default PurchaseBill;

